import React, { FC } from 'react';
import styles from './notification_link_date.module.scss';

export const NotificationLinkDate: FC = ({ children }) => (
  <span className={styles.container}>{children}</span>
);
